import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NzImageModule } from 'ng-zorro-antd/image';

@Component({
  selector: 'app-image-open-in-full',
  standalone: true,
  imports: [CommonModule, FormsModule, NzImageModule, MatTooltipModule],
  templateUrl: './image-open-in-full.component.html',
  styleUrl: './image-open-in-full.component.scss',
})
export class ImageOpenInFullComponent {
  @Input({ required: true }) width!: string;
  @Input({ required: true }) src!: string;
}
